import * as React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
	background: ${(p) =>
		p.noBackground ? 'transparent' : 'linear-gradient(-45deg, #376df0, #19ddff)'};
	width: ${(p) => p.size};
	height: ${(p) => p.size};
`;

export class VoucherIcon extends React.Component {
	static defaultProps = { size: '6rem' };
	static paths = null;
	static fetch = null;

	componentDidMount = async () => {
		if (VoucherIcon.paths) {
			this.setState(VoucherIcon.paths);
		} else {
			// vouche icons should only be fetched once, so we assign the promise with them to the class
			if (!VoucherIcon.fetch) {
				VoucherIcon.fetch = (async () => {
					const res = await fetch('https://static.cinuru.com/public/voucher-icon-paths.json');
					return await res.json();
				})();
			}
			VoucherIcon.paths = await VoucherIcon.fetch;
			this.setState(VoucherIcon.paths);
		}
	};

	renderIcon = (paths) => {
		const { name, size } = this.props;
		return (
			<svg width={size} height={size} viewBox="0 0 40 40">
				<path fill="white" d={paths[name]} />
			</svg>
		);
	};

	render = () => {
		const paths = this.state;
		const { noBackground, size } = this.props;
		return !paths ? null : noBackground ? (
			this.renderIcon(paths)
		) : (
			<Wrapper noBackground={noBackground} size={size}>
				{this.renderIcon(paths)}
			</Wrapper>
		);
	};
}



// WEBPACK FOOTER //
// ./src/components/VoucherIcon.js